export default __webpack_public_path__ + "static/IBMPlexSans-Text-Latin1-458a38d4e128238f1f30f65a2ef9025e.woff2";